<template>
    <v-container class="calendar-container">
        <div class="filters">
            <v-checkbox
                v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_CONTRACTOR'], userRoles)"
                v-model="assignmentsCheck"
                label="Αναθέσεις Εργολάβου"
                style="font-weight: bold;"
                color="blue"
                @change="onChange"
            ></v-checkbox>
            <v-checkbox
                v-model="taskAssignmentsCheck"
                label="Αναθέσεις Εργασιών"
                style="font-weight: bold;"
                color="blue"
                :disabled="assignmentsCheck"
                @change="onChange"
            ></v-checkbox>
            <v-checkbox
                v-model="desiredTaskAssignmentsCheck"
                label="Επιθυμητές Αναθέσεις Εργασιών"
                style="font-weight: bold;"
                color="blue"
                :disabled="assignmentsCheck"
                @change="onChange"
            ></v-checkbox>
        </div>
        <div class="info-container-wrapper">
            <div v-if="containsAny(['ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_CONTRACTOR'], userRoles)" class="info-container">
                <v-avatar
                    color="blue"
                    size="15"
                ></v-avatar>
                <span class="info-text">Αναθέσεις Έργου σε Εργολάβο</span>
            </div>
            <div class="info-container">
                <v-avatar
                    color="#009688"
                    size="15"
                ></v-avatar>
                <span class="info-text">Ολοκληρωμένη Εργασία</span>
            </div>
            <div class="info-container">
                <v-avatar
                    color="#CC5500"
                    size="15"
                ></v-avatar>
                <span class="info-text">Μη Ολοκληρωμένη Εργασία</span>
            </div>
            <div class="info-container">
                <v-avatar
                    color="rgb(240, 188, 104)"
                    size="15"
                ></v-avatar>
                <span class="info-text">Επιθυμητές Αναθέσεις Εργασιών</span>
            </div>
        </div>
        <div class="options">
            <v-select
                v-if="containsAny(['ROLE_ADMIN'], userRoles) || (containsAny(['ROLE_COORDINATOR'], userRoles) && userIsFromCompany)"
                v-model="selectedContractor"
                :items="contractors"
                item-value="id"
                item-text="name"
                label="Εργολάβος"
                clearable
                outlined
                class="field"
                hide-details
            >
                <template v-slot:selection="data">
                    <span class="font-weight-bold">{{ data.item.name }}</span>
                </template>
            </v-select>
            <v-select
                v-if="containsAny(['ROLE_ADMIN'], userRoles) || (containsAny(['ROLE_COORDINATOR'], userRoles) && userIsFromCompany) || (this.userIsContractorOrCoordinator && this.userContractor)"
                v-model="selectedAssignee"
                :items="contractorUsers"
                item-value="id"
                label="Υπάλληλος"
                clearable
                outlined
                class="field"
                hide-details
                :disabled="!selectedContractor || this.assignmentsCheck"
            >
                <template v-slot:item="{ item }">
                    <div class="assignee-selection">
                        <span class="assignee-name">{{ item.firstName }} {{ item.lastName }}</span>
                        <v-chip-group
                            active-class="primary--text"
                            class = "group-chips"
                        >
                            <v-chip
                                v-for="role in item.roles"
                                :key="role.role"
                                :color="getRoleColor(role.role)"
                                class="role-chip"
                                disabled
                            >
                                {{ getRoleText(role.role) }}
                            </v-chip>
                        </v-chip-group>
                    </div>
                </template>
                <template v-slot:selection="data">
                    <span class="font-weight-bold">{{ data.item.firstName }} {{ data.item.lastName }}</span>
                </template>
            </v-select>
            <v-select
                v-model="selectedTaskType"
                :items="taskAssignmentOptions"
                item-text="text"
                item-value="value"
                label="Εργασία"
                outlined
                clearable
                class="field"
                hide-details
                :disabled="this.assignmentsCheck"
            ></v-select>
        </div>
        <v-sheet>
            <div v-if="loading" class="loading-overlay">
                <div class="loader" />Φόρτωση ημερολογίου..
            </div>
            <full-calendar v-show="!loading" ref="fullCalendar" :options="calendarOptions" />
            <v-menu v-model="selectedOpen" :close-on-content-click="false" absolute :position-x="600" :position-y="300" max-width="380">
                <v-card color="grey lighten-4" min-width="300px" flat>
                    <v-toolbar :color="selectedEvent.taskColor" dark>
                        <v-toolbar-title v-if="!selectedEvent.isAssignment" class="toolbar-title">
                            {{ `${taskAssignmentTexts[selectedEvent.type]}  -  ${selectedEvent.sr}` }}
                            <v-icon v-if="selectedEvent.status === 'COMPLETED'">mdi-check</v-icon><v-icon v-else>mdi-close</v-icon>
                        </v-toolbar-title>
                        <v-toolbar-title v-else class="toolbar-title">
                            {{ `${selectedEvent.contractor}  -  ${selectedEvent.sr} ` }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-subtitle v-if="selectedEvent.isAssignment && selectedEvent.contractor" class="contractor-name">{{ selectedEvent.contractor }}</v-card-subtitle>
                    <v-card-text>
                        <div>
                            <span>Status Ανάθεσης:</span>
                            <assignment-status-label :status="selectedEvent.assignmentStatus" class="status-label" />
                        </div>
                        <div>
                            Υλικα
                            <v-dialog
                                v-model="dialog3"
                                width="700"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        class="white--text"
                                        x-small
                                        :color="'black'"
                                        :disabled="!selectedEvent.prodesmeusiMaterials"
                                    >
                                        Προβολη
                                        <v-icon>mdi-eye-outline</v-icon>
                                    </v-btn>
                                </template>
                                <prodesmeusi-materials :prodesmeusiMaterials="selectedEvent.prodesmeusiMaterials"/>
                            </v-dialog>
                        </div>
                        <div v-if="!selectedEvent.isAssignment">
                            <span>Κατάσταση Εργασίας:</span> <span class="font-bold">{{ taskAssigmentStatus[selectedEvent.status] }}</span>
                        </div>
                        <div v-if="!selectedEvent.isAssignment">
                            <span>Ανάθεση στον:</span> <span class="font-bold">{{ selectedEvent.assignee?.firstName }} {{ selectedEvent.assignee?.lastName }}</span>
                        </div>
                        <div v-if="!selectedEvent.isAssignment">
                            <span>Από Εργολάβο:</span> <span v-if="selectedEvent.contractor" class="font-bold">{{ selectedEvent.contractor }}</span>
                        </div>
                        <div>
                            <span>Πελάτης:</span> <span class="font-bold">{{ selectedEvent.client }}</span>
                        </div>
                        <div>
                            <span>Τηλ:</span> <span class="font-bold">{{ selectedEvent.phoneNumber }}</span>
                        </div>
                        <div>
                            <span>Περιοχή:</span> <span class="font-bold">{{ selectedEvent.location }}</span>
                        </div>
                        <div>
                            <span>Διεύθυνση:</span> <span class="font-bold">{{ selectedEvent.address }}</span>
                        </div>
                        <div>
                            Optical Path
                            <v-dialog
                                v-model="dialog"
                                width="700"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        class="white--text"
                                        x-small
                                        :color="'black'"
                                        :disabled="!selectedEvent.opticalPath"
                                    >
                                        Προβολη
                                        <v-icon>mdi-eye-outline</v-icon>
                                    </v-btn>
                                </template>
                                <optical-path :opticalPath="selectedEvent.opticalPath"/>
                            </v-dialog>
                        </div>
                        <div v-if="selectedEvent.description">
                            Σχόλιο Ανάθεσης
                            <v-dialog
                                v-model="dialog2"
                                width="600"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        class="white--text"
                                        x-small
                                        :color="'black'"
                                        :disabled="!selectedEvent.description"
                                    >
                                        Προβολη
                                        <v-icon>mdi-eye-outline</v-icon>
                                    </v-btn>
                                </template>
                                <v-card class="dialog">
                                    <v-card-title class="text-h5 card-text">
                                        Σχόλιο Ανάθεσης
                                    </v-card-title>
                                    <v-card-text> {{ selectedEvent.description }} </v-card-text>
                                </v-card>
                            </v-dialog>
                        </div>
                    </v-card-text>
                    <v-card-actions class="card-actions">
                        <v-btn color="secondary" @click="$router.push({ path: `/assignments/${selectedEvent.assignmentId}/edit?tab=${selectedEvent.type}` })">
                            Επεξεργασια
                        </v-btn>
                        <v-btn color="secondary" @click="selectedOpen = false">
                            Κλεισιμο
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </v-sheet>
    </v-container>
</template>

<script>
    import ProdesmeusiMaterials from '@/components/ProdesmeusiMaterials'
    import momentTimezone from 'moment-timezone'
    import assignment from '@/services/assignment'
    import taskAssignment from '@/services/task-assignment'
    import AssignmentStatusLabel from '@/components/AssignmentStatusLabel.vue'
    import OpticalPath from '@/components/OpticalPath'
    import client from '@/services/client'
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import interactionPlugin from '@fullcalendar/interaction'
    import elLocale from '@fullcalendar/core/locales/el'
    import user from '@/services/user'
    import userMixin from '@/mixins/user'

    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME

    export default {
        components: { AssignmentStatusLabel, OpticalPath, ProdesmeusiMaterials, FullCalendar },
        mixins: [ userMixin ],
        computed: {
            currentUserId() {
                return Number(this.$store.getters.getUserId)
            },
            userRoles() {
                return this.currentUser?.roles.map(role => role.role) || []
            },
            userIsFromCompany() {
                return this.currentUser?.contractor?.name.toLowerCase() === COMPANY_NAME.toLocaleLowerCase()
            },
            userContractor() {
                return this.currentUser?.contractor?.id
            },
            userIsContractorOrCoordinator() {
                return this.userRoles.includes('ROLE_CONTRACTOR') || this.userRoles.includes('ROLE_COORDINATOR')
            }
        },
        watch: {
            selectedTaskType: {
                handler(newVal, oldVal) {
                    this.onChange()
                }
            },
            selectedContractor: {
                handler(newVal, oldVal) {
                    this.onChange()
                    if (newVal) {
                        this.getContractorUsers(newVal)
                    } else {
                        this.contractorUsers = []
                    }
                }
            },
            selectedAssignee: {
                handler(newVal, oldVal) {
                    this.onChange()
                }
            }
        },
        data: () => ({
            calendarOptions: {
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                datesSet: () => {},
                dateClick: () => {},
                eventClick: () => {},
                headerToolbar: {
                    left: 'prev next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridDay'
                },
                locales: [elLocale],
                expandRows: true,
                eventDisplay: 'block',
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                },
                initialView: 'dayGridDay',
                events: []
            },
            contractors: [],
            selectedAssignee: null,
            contractorUsers: [],
            focus: '',
            eventsToDisplay: [],
            assignmentsCheck: false,
            taskAssignmentsCheck: true,
            desiredTaskAssignmentsCheck: false,
            assignments: [],
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            selectedContractor: null,
            taskAssignmentTexts: {
                autopsy: 'Αυτοψία',
                earthwork: 'Χωματουργικά',
                blowing: 'Εμφύσηση',
                construction: 'Κατασκευή',
                welding: 'Κολλήσεις / Μετρήσεις',
                oto: 'ΟΤΟ',
                activation: 'Ενεργοποίηση'
            },
            taskAssignmentOptions: [],
            taskAssigmentStatus: {
                COMPLETED: 'Ολοκληρωμένη',
                PENDING: 'Εκκρεμεί'
            },
            selectedTaskType: null,
            min: null,
            max: null,
            events: [],
            dialog: false,
            dialog2: false,
            dialog3: false,
            currentUser: null,
            loading: false
        }),
        created() {
            this.getCurrentUser()
            this.taskAssignmentOptions = Object.entries(this.taskAssignmentTexts).map(([key, value]) => ({ value: key, text: value }))
            this.calendarOptions.datesSet = (info) => this.getCalendar(info.start, info.end)
            this.calendarOptions.dateClick = (info) => this.onDateClick(info.date)
            this.calendarOptions.eventClick = (info) => this.showEvent(info.event._def.extendedProps, info.el)
            this.getClients()
        },
        methods: {
            getContractorUsers(contractorId) {
                user.getContractorUsers(contractorId).then(resp => {
                    this.contractorUsers = resp.data
                })
            },
            getCurrentUser() {
                user.getCurrentUser().then(resp => {
                    this.currentUser = resp.data
                    if (this.userIsContractorOrCoordinator && this.userContractor) {
                        this.selectedContractor = this.userContractor
                    }
                })
            },
            onDateClick(date) {
                const calendarApi = this.$refs.fullCalendar.getApi()
                calendarApi.changeView('dayGridDay', date)
            },
            getEventsToDisplay() {
                this.calendarOptions.events = []
                if (this.selectedTaskType) {
                    this.events = this.events.filter(event => event.type === this.selectedTaskType || !event.type)
                }
                if (this.selectedContractor) {
                    this.events = this.events.filter(event => event.contractorId === this.selectedContractor)
                }
                if (this.selectedAssignee && !this.assignmentsCheck) {
                    this.events = this.events.filter(event => event.assignee?.id === this.selectedAssignee)
                }
                this.calendarOptions.events = this.events
                this.loading = false
            },
            onChange() {
                this.getCalendar(this.min, this.max)
            },
            async getCalendar(min, max) {
                if (!min || !max) {
                    return
                }
                this.loading = true

                this.min = min
                this.max = max
                this.events = []
                let query = {}

                query.startDate = momentTimezone(this.min).tz('Europe/Athens').startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                query.endDate = momentTimezone(this.max).tz('Europe/Athens').startOf('day').utc().add(1, 'day').format('YYYY-MM-DD[T]HH:mm:ss[Z]')

                if (this.assignmentsCheck) {
                    this.getAssignments(query)
                    return
                }
                if (this.desiredTaskAssignmentsCheck) {
                    this.getTaskAssignments(query, true)
                }
                if (this.taskAssignmentsCheck) {
                    this.getTaskAssignments(query, false)
                }
                if (!this.assignmentsCheck && !this.desiredTaskAssignmentsCheck && !this.taskAssignmentsCheck) {
                    this.loading = false
                }
            },
            getTaskAssignments(query, isDesired) {
                const events = []
                taskAssignment.getBetweenDates(query, isDesired).then(resp => {
                    resp.data.forEach(taskAssignment => {
                        events.push({
                            id: taskAssignment.id,
                            title: `**${this.taskAssignmentTexts[taskAssignment.type?.toLowerCase()]}**  ${taskAssignment.assignee.firstName || ''} ${taskAssignment.assignee.lastName || ''}  |  ${taskAssignment.address}, ${taskAssignment.location}`,
                            contractorId: taskAssignment.assignee.contractor?.id,
                            contractor: taskAssignment.assignee.contractor?.name,
                            sr: taskAssignment.assignmentSr,
                            assignee: taskAssignment.assignee,
                            assignmentId: taskAssignment.assignmentId,
                            type: taskAssignment.type?.toLowerCase(),
                            client: taskAssignment.clientName,
                            phoneNumber: taskAssignment.phoneNumber,
                            manager: taskAssignment.manager,
                            buildingId: taskAssignment.buildingId,
                            address: taskAssignment.address,
                            location: taskAssignment.location,
                            assignmentStatus: taskAssignment.assignmentStatus,
                            backgroundColor: isDesired ? 'rgb(240, 188, 104)' : (taskAssignment.status === 'COMPLETED' ? '#009688' : '#CC5500'),
                            taskColor: isDesired ? 'rgb(240, 188, 104)' : (taskAssignment.status === 'COMPLETED' ? '#009688' : '#CC5500'),
                            timed: false,
                            description: taskAssignment.description,
                            status: taskAssignment.status,
                            opticalPath: taskAssignment.opticalPath,
                            prodesmeusiMaterials: taskAssignment.prodesmeusiMaterials,
                            start: this.calculateDatime(taskAssignment, isDesired),
                            end: this.calculateDatime(taskAssignment, isDesired)
                        })
                    })
                    this.events = this.events.concat(events)
                    this.getEventsToDisplay()
                }).catch((error) => {
                    console.log(error)
                })
            },
            getClients() {
                client.getAllClients().then(resp => {
                    const clients = resp.data
                    clients.forEach(client => { this.contractors = this.contractors.concat(client.contractors) })
                })
            },
            calculateDatime(taskAssignment, isDesired) {
                if (isDesired) {
                    return momentTimezone(taskAssignment.datetime).tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString()
                }
                if (!taskAssignment.finalDatetime) {
                    return
                }
                return momentTimezone(taskAssignment.finalDatetime).tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString()
            },
            getAssignments(query) {
                const events = []
                assignment.getOnContractorsBetweenDates(query).then(resp => {
                    resp.data.forEach(assignment => {
                        events.push({
                            id: assignment.id,
                            assignmentId: assignment.id,
                            color: 'blue',
                            isAssignment: true,
                            title: `${assignment.sr} - ${assignment.contractor?.name || ''}  |  ${assignment.address}, ${assignment.location?.name}`,
                            contractorId: assignment.contractor?.id,
                            contractor: assignment.contractor?.name,
                            sr: assignment.sr,
                            client: assignment.clientName,
                            phoneNumber: assignment.phoneNumber,
                            manager: assignment.manager,
                            buildingId: assignment.buildingId,
                            address: assignment.address,
                            location: assignment.location?.name,
                            description: assignment.description,
                            assignmentStatus: assignment.status,
                            opticalPath: assignment?.autopsy?.opticalPath,
                            timed: false,
                            start: momentTimezone(assignment.assignedToContractorAt).tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString(),
                            end: momentTimezone(assignment.assignedToContractorAt).tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString()
                        })
                    })
                    this.events = this.events.concat(events)
                    this.getEventsToDisplay()
                }).catch((error) => {
                    console.log(error)
                })
            },
            showEvent(event, element) {
                this.selectedEvent = event
                this.selectedElement = element
                this.selectedOpen = true
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            }
        }
    }
</script>

<style scoped>
.card-actions {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
}
.v-select.v-input.v-input--is-disabled {
  background-color: #f5f5f5;   /* light gray background */
  color: #999;                 /* gray text */
  cursor: not-allowed;         /* show disabled cursor */
  opacity: 0.6;                /* make it look inactive */
}

.v-input.v-input--is-disabled {
  cursor: not-allowed;         /* show disabled cursor */
  opacity: 0.6;                /* make it look inactive */
}

.loading-overlay {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
}
.loader {
  width: 80px;
  height: 80px;
  border: 8px solid rgba(255, 255, 255, 0.3);
  border-top: 8px solid #3498db;
  border-radius: 50%;
  margin-bottom: 1rem;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.assignee-name {
    font-weight: 500;
}
.role-chip {
    color: white;
}
.v-chip--disabled {
    opacity: 1;
}
.assignee-selection {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.centered-menu {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
.info-container-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}
.info-text {
    margin-left: 0.2rem;
    color: var(--cards-and-tables-text-color) !important;
    font-size: 0.8rem;
}
.info-container {
    display: flex;
    align-items: center;
    margin: 0.3rem;
}

.filters {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    min-height: 40px;
}
.options {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 1rem;
}

.field {
    min-width: 200px;
    max-width: 300px;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    margin-right: 1rem;
}
.contractor-name {
    font-size: 1rem;
    font-weight: 500;
}
.font-bold {
    font-weight: 600;
}

.toolbar-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.status-label {
    margin-left: 1rem;
    height: 1.1rem;
    font-size: 0.8rem;
}

</style>
<style>
.fc-toolbar-title {
    color: var(--cards-and-tables-text-color) !important;
}
.fc {
    background-color: var(--background-color) !important;
}
.fc .fc-button .fc-icon {
    vertical-align: bottom;
}
.fc-view-harness {
    min-height: 800px;
}

.fc-daygrid-day-number, .fc-col-header-cell-cushion {
  color: var(--cards-and-tables-text-color) !important;
}

.fc-header-toolbar {
    display: flex;
    flex-wrap: wrap;
}
.fc-day-today {
  background-color: #2195f32a !important;
  color: var(--cards-and-tables-text-color) !important;
}
.fc-daygrid-event .fc-event-time {
  display: block;
  font-weight: bold;
  min-width: 100px;
}
.fc-event-main-frame {
    max-width: 100%S;
    display: flex;
    flex-wrap: wrap;
}
.fc-daygrid-event .fc-event-title {
  display: block;
  white-space: normal;
}
</style>
